import React from "react";
import Slide from "../../utils/images/gift-registry-1920.jpg";
import { HeartFilled, DownOutlined } from "@ant-design/icons";
import { HeartStyle } from "../data/data";
import styled from "styled-components";
const Layout = styled.div`
  font-family: "Oswald" sans-serif;
  .icon-style {
    font-size: 47px;
    font-weight: 800;
    color: white;
  }
  .text {
    font-size: 120%;
    font-weight: 800;
    margin-bottom: 24px;
    color: white;
    padding: 30px;
    font-family: sans-serif;
    text-align: center;
  }
  .title {
    letter-spacing: 3px;
    font-size: 35px;
    font-weight: 700;
    margin-bottom: 24px;
    padding: 30px;
    color: white;
    font-family: sans-serif;
    text-align: center;
  }
`;

function Banner() {
  return (
    <>
      <Layout>
        <div style={styles.banner}>
          <h3 className="title">GIFT REGISTRY</h3>
          <HeartStyle>
            <span className="white-line"></span>
            <HeartFilled style={{ fontSize: 19, zIndex: 20, color: "red" }} />
            <HeartFilled
              style={{
                fontSize: 19,
                marginLeft: -5,
                color: "white",
              }}
            />
            <span className="white-line"></span>
          </HeartStyle>
          <span className="text">
            Lorem ipsum dolor adipiscing elit. Integer ultrices quis Nullam non
            bibendum <br /> dolor. Ut vel turpis accumsan, efficitur Lorem ipsum
            dolor adipiscing elit.
            <br /> Integer ultrices malesuada ante quis pharetra. Lorem ipsum
            <br /> Nullam non bibendum dolor. Ut vel turpis accumsan, efficitur
          </span>
          <span>
            <DownOutlined className="icon-style" />
          </span>
        </div>
      </Layout>
    </>
  );
}
const styles = {
  banner: {
    background: `linear-gradient(0deg,rgba(15,210,10,0.5),rgba(100,170,210,0.5)),url(${Slide})`,
    minHeight: 470,
    backgroundSize: "cover",
    padding: 20,
    backgroundPosition: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    alignItems: "center",
    textAlign: "center",
  },
};

export default Banner;
